// src/pages/pengamatan/buah-alami/FormBuahAlami.jsx
import React, { useState, useEffect } from "react";
import "./FormBuahAlami.css";

{/*  */}

const FormBuahAlami = () => {
    return (
        <div className="container" id="pdf-content">
            {/* Header dengan logo, judul, dan informasi perusahaan // */}
            <div className="doc-header">
                {/* Section untuk logo dan perusahaan */}
                <div className="company-section">
                    {/* Area untuk logo SVG */}
                    <div className="logo-container">
                        <img
                            src="/ggp.png"
                            alt="Logo GGF"
                            style={{ width: "60px", height: "auto", borderRadius: "8px" }}
                            className="company-logo"
                        />
                    </div>

                    {/* Informasi perusahaan */}
                    <div className="company-info">
                        <div className="company-name">PT. Great Giant Pineapple</div>
                        <div>Plantation Group Dept 4</div>
                        <div>Pengamatan Pertumbuhan Nanas</div>
                    </div>
                </div>

                {/* Judul dokumen */}
                <div className="title-doc">
                    <h1>Pengamatan Buah Alami</h1>
                </div>

                {/* Informasi dokument */}
                <div className="doc-info">
                    <div className="doc-info-area">
                        <div className="doc-row">
                            <span className="doc-label">No. Doc</span>
                            <span className="doc-label-2"> : </span>
                            <span className="doc-value">F/NF/PLT/PPTN/G.04</span>
                        </div>
                        <div className="doc-row">
                            <span className="doc-label">Rev.</span>
                            <span className="doc-label-2"> : </span>
                            <span className="doc-value">2</span>
                        </div>
                        <div className="doc-row">
                            <span className="doc-label">Date Issue</span>
                            <span className="doc-label-2"> : </span>
                            <span className="doc-value">11 November 2025</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="doc-body">
                <div className="info-doc">
                    <div className="info-row">
                        {/* Bagian kiri */}
                        <div className="info-left">
                            <div className="info-item">
                                <label>Hari/Tanggal</label>
                                <span className="colon">:</span>
                                <span className="input-line" id="hari-tanggal"></span>
                            </div>

                            <div className="info-item">
                                <label>Bagian Unit Kerja</label>
                                <span className="colon">:</span>
                                <span className="input-line short" id="bagian-unit-kerja"></span>
                                <label className="inline">PPN</label>
                                <span className="input-line short" id="ppn"></span>
                            </div>

                            <div className="info-item">
                                <label>Status</label>
                                <span className="colon">:</span>
                                <span className="input-line" id="status-lokasi"></span>
                            </div>
                        </div>

                        {/* Bagian kanan */}
                        <div className="info-right">
                            <div className="info-item">
                                <label>Halaman</label>
                                <span className="colon">:</span>
                                <span className="input-line short"></span>
                                <label className="inline">Dari</label>
                                <span className="input-line short"></span>
                            </div>

                            <div className="info-item">
                                <label>Pengamat</label>
                                <span className="colon">:</span>
                                <span className="input-line" id="nama-pengamat"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <table className="table-form">
                    <tr className="section-title">
                        {/*Header - Info Lokasi*/}
                        <td className="td-form" colSpan="4">
                            Info Lokasi
                        </td>

                        {/*Header - Tabulasi*/}
                        <td className="td-form" colSpan="25">
                            Tabulasi
                        </td>

                        {/*Header - Populasi/Ha*/}
                        <td className="td-form" colSpan="2">
                            Populasi/Ha
                        </td>
                    </tr>

                    <tr className="section-title">
                        {/*Sub Header - Info Lokasi*/}
                        <td className="td-form multirowspan" rowSpan="3">
                            Lokasi
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            Plot
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            Luas
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            PJP
                        </td>

                        {/*Sub Header - Tabulasi*/}
                        <td className="td-form" colSpan="16">
                            Fase Bunga Alami
                        </td>
                        <td className="td-form" colSpan="4">
                            Berbunga
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            Buah Alami
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            Mati
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            Total
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            Spot Mati
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            % Buah Alami
                        </td>

                        {/*Sub Header - Populasi/Ha*/}
                        <td className="td-form multirowspan" rowSpan="3">
                            Normal
                        </td>
                        <td className="td-form multirowspan" rowSpan="3">
                            Total
                        </td>
                    </tr>

                    <tr className="section-title">
                        {/*Sub Sub Header - Tabulasi - Fase Bunga Alami*/}
                        <td rowSpan="1" className="td-form custom-border">
                            Open Heart
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Red Bud 1.25
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Red Bud 2.54
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Early Cones
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Mid Cones
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Late Cones
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Early Petals
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Mid Petals
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Late Petals
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Dry Petals
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Filling Stage 1
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            Filling Stage 2
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            SC0
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            SC0&gt;
                        </td>
                        <td rowSpan="2" className="td-form multirowspan">
                            Terpetik
                        </td>
                        <td rowSpan="2" className="td-form multirowspan">
                            Dimakan Tikus
                        </td>

                        {/*Sub Sub Header - Tabulasi - Berbunga*/}
                        <td rowSpan="2" className="td-form multirowspan">
                            Normal
                        </td>
                        <td rowSpan="1" colSpan="2" className="td-form">
                            Penyakit
                        </td>
                        <td rowSpan="2" className="td-form multirowspan">
                            Kerdil
                        </td>
                    </tr>

                    <tr className="section-title">
                        {/*Sub Sub Sub Header - Tabulasi - Fase Bunga Alami - Open Heart sampai SC0>*/}
                        <td rowSpan="1" className="custom-border td-form">
                            (36-37)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (39-40)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (42-44)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (46-48)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (51-53)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (54-56)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (57-58)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (60-62)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (64-65)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (67-72)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (73-105)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (106-125)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (126-130)
                        </td>
                        <td rowSpan="1" className="td-form custom-border">
                            (&gt;130)
                        </td>

                        {/*Sub Sub Sub Header - Tabulasi - Berbunga - Penyakit*/}
                        <td rowSpan="1" className="td-form">
                            phy
                        </td>
                        <td rowSpan="1" className="td-form">
                            erw
                        </td>
                    </tr>

                    {/* Data plot rows - menggunakan React rendering */}
                    <tbody id="plot-data-body" >
                        
                    </tbody>
                </table>
            </div>

            {/* Area doc-footer untuk tanda tangan */}
            <div className="doc-footer">
                <div className="note-footer">
                    <div className="note-footer-container">
                        <div className="container-section">
                            <h2>Catatan</h2>
                            <p></p>
                        </div>
                    </div>
                </div>
                <div className="validation-footer">
                    <div className="footer-left">
                        <div className="footer-section">
                            <div className="footer-header">Diamati Oleh,</div>
                            <div className="signature-area" id="signature-petugas-ppn"></div>
                            <div className="signature-name" id="petugas-ppn"></div>
                            <div className="signature-label">Petugas PPN</div>
                        </div>
                        <div className="footer-section">
                            <div className="footer-header">Diperiksa Oleh,</div>
                            <div className="signature-area" id="signature-mandor-ppn"></div>
                            <div className="signature-name" id="mandor-ppn"></div>
                            <div className="signature-label">Mandor PPN</div>
                        </div>
                    </div>
                    <div className="footer-right">
                        <div className="footer-section">
                            <div className="footer-header">Diterima Oleh,</div>
                            <div className="signature-area" id="signature-sect-head-wilayah"></div>
                            <div className="signature-name" id="sect-head-wilayah">
                                Admad Erdiyanto
                            </div>
                            <div className="signature-label">Sect. Head. PPN</div>
                        </div>
                        <div className="footer-section">
                            <div className="footer-header">Diketahui Oleh,</div>
                            <div className="signature-area" id="signature-sub-dept-head"></div>
                            <div className="signature-name" id="sub-dept-head-wilayah">
                                -
                            </div>
                            <div className="signature-label">Sect. Head. Kebun</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormBuahAlami;